import { SearchRangeTerms } from '../../models/search-range-terms.models';

export class DateRangeTerm {
  constructor(public dateRange: DateRange, public searchRangeTerm: SearchRangeTerms | undefined) {}
}

export class DateRange {
  public utcStartDate: string;
  public utcEndDate: string;

  constructor(public startDate: Date, public endDate: Date) {
    this.utcStartDate = startDate.toISOString();
    this.utcEndDate = endDate.toISOString();
  }
}

export class DateRangeModel {
  constructor(public startDate: Date, public endDate: Date) {}
}
